import Pagination from './ant';

export default Pagination;
